var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronDownIndigo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51643 7.67805C3.76051 7.43398 4.15624 7.43398 4.40032 7.67805L10 13.2778L15.5998 7.67805C15.8438 7.43398 16.2396 7.43398 16.4836 7.67805C16.7277 7.92213 16.7277 8.31786 16.4836 8.56194L10.442 14.6036C10.1979 14.8477 9.80218 14.8477 9.5581 14.6036L3.51643 8.56194C3.27235 8.31786 3.27235 7.92213 3.51643 7.67805Z",
    fill: "#1C3D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownIndigo);
export default __webpack_public_path__ + "static/media/icon-chevron-down-indigo.b7bc8dd0935ec94535f85ef5cee7abb5.svg";
export { ForwardRef as ReactComponent };